import React from "react";

import FundsLedgerContent from "../components/payments-linking/funds-ledger";

const FundsLedger = () => {
  return <FundsLedgerContent />;
};

export default FundsLedger;
